export default {
    ...(window.__CONFIG__ || {}),
    cpaUrl: process.env.REACT_APP_CPA_URL,
    shortUrl: process.env.REACT_APP_SHORTENER_URL,
    adminUrl: process.env.REACT_APP_ADMIN_URL,
    tdsUrl: process.env.REACT_APP_TDS_URL,
    clientId: process.env.REACT_APP_CLIENT_ID,
    sideBarUrl: process.env.REACT_APP_SIDEBAR_URL,
    advertiserUrl: process.env.REACT_APP_ADVERTISER_URL
};

export const cap = require("./img/offers/default.jpg");

export const sidebar = [
    {
        key: "dashboard",
        exact: true,
        icon: "offers",
    },
    {
        key: "goals",
        nameKey: "offerings",
        icon: "home",
        href: "offers/",
    },
    {
        key: "statistics",
        icon: "statistics",
        href: "statistics/",
        subMenu: [
            {
                key: "report",
                href: "statistics/report",
            },
            {
                key: "conversions",
                href: "statistics/conversion",
            },
        ],
    },
    {
        key: "finance",
        icon: "finance",
        href: "/office/finances",
        subMenu: [
            {
                key: 'financeReport',
                nameKey: 'financialReport',
                href: '/office/finances/report'
            },
            {
                key: "historyFinance",
                nameKey: "operationsHistory",
                href: "/office/finances/history",
            }
        ],
    },
    {
        key: "information",
        href: "office/settings/information",
        icon: "information",
    },
];

export const statistics = {
    groupParams: [
        "Day",
        "Hour",
        "Week",
        "Month",
        "Quarter",
        "Year",
        "WeekDay",
        "DayHour",
        "Offer",
        "Publisher",
        "Goal",
        "Link",
        "UtmMedium",
        "UtmSource",
        "UtmCampaign",
        "UtmTerm",
        "UtmContent",
        "Param1",
        "Param2",
        "Param3",
        "Param4",
        "Country",
        "District",
        "Area",
        "City",
        "Rejected",
        "DeviceType",
        "DeviceOs",
        "RefererDomain",
        "RefererSignificantSubdomain",
        "RefererPath",
        "RefererPage",
        "CreativeType",
        "CreativeId",
    ],
    groupParamsSegment: [
        "Publisher",
        "Offer",
        "Goal",
        "Link",
        "UtmMedium",
        "UtmSource",
        "UtmCampaign",
        "UtmTerm",
        "UtmContent",
        "Param1",
        "Param2",
        "Param3",
        "Param4",
        "Country",
        "District",
        "Area",
        "City",
        "Rejected",
        "DeviceType",
        "DeviceOs",
        "CreativeType",
        "CreativeLinkId",
        "CreativeContainerId",
        "CreativeBannerId",
        "CreativeLandingId",
        "CreativePromoCodeId"
    ],
};

export const statuses = {
    paused: "paused",
    active: "active",
};

export const locales = [
    {
        key: "uk",
        name: "UK",
        image: require("./img/flags/4x3/uk.svg"),
    },
    {
        key: "en",
        name: "EN",
        image: require("./img/flags/4x3/en.svg"),
    },
    {
        key: "ru",
        name: "RU",
        image: require("./img/flags/4x3/ru.svg"),
    },
];

export const phoneCodesCountries = [
    {
        value: "7",
        code: "RU",
    },
    {
        value: "77",
        code: "KZ",
    },
    {
        value: "375",
        code: "BY",
    },
    {
        value: "994",
        code: "AZ",
    },
    {
        value: "374",
        code: "AM",
    },
    {
        value: "44",
        code: "GB",
    },
    {
        value: "84",
        code: "VN",
    },
    {
        value: "9955",
        code: "GE",
    },
    {
        value: "972",
        code: "IL",
    },
    {
        value: "91",
        code: "IN",
    },
    {
        value: "996",
        code: "KG",
    },
    {
        value: "371",
        code: "LV",
    },
    {
        value: "370",
        code: "LT",
    },
    {
        value: "373",
        code: "MD",
    },
    {
        value: "507",
        code: "PA",
    },
    {
        value: "40",
        code: "RO",
    },
    {
        value: "1",
        code: "US",
    },
    {
        value: "992",
        code: "TJ",
    },
    {
        value: "66",
        code: "TH",
    },
    {
        value: "90",
        code: "TR",
    },
    {
        value: "998",
        code: "UZ",
    },
    {
        value: "380",
        code: "UA",
    },
    {
        value: "372",
        code: "EE",
    },
    {
        value: "82",
        code: "KR",
    },
    {
        value: "81",
        code: "JP",
    },
];

export const timeInterval = [
    {value: "Hour", key: "hour"},
    {value: "Day", key: "day"},
    {value: "Week", key: "week"},
    {value: "Month", key: "month"},
];

export const mimeTypes = {
    "image/gif": "Gif",
};
